import React from 'react';
import communityImage from '../assets/image4.jpg';

const gifBackground = "https://ik.imagekit.io/confesz/main22.avif";

function About() {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Video Section */}
      <div className="relative h-screen">
        <div className="absolute inset-0 w-full h-full overflow-hidden">
          <img
            src={gifBackground}
            alt="Background animation"
            className="absolute min-w-full min-h-full object-cover"
            style={{ filter: 'brightness(50%)' }}
          />
        </div>
        {/* Title Overlay */}
        <div className="relative z-10 h-full flex items-center justify-center">
          <h1 className="text-4xl font-bold text-white">About Us</h1>
        </div>
      </div>
      {/* Text Content Section */}
      <div className="bg-black text-white py-16">
        <div className="max-w-4xl mx-auto space-y-6 mb-8 px-4">
          <p className="text-2xl text-center whitespace-pre-line">
            {`In a world where the internet is becoming less private every day, we at ConfesZ prioritize your privacy and freedom of speech above all else.
            Our mission is to create an environment where people can share freely without fear.`}
          </p>
          <div className="h-10"></div> {/* Spacer div */}
          <div className="space-y-6 mb-8">
            <p className="text-lg">
              At ConfesZ, we believe that sharing your experiences and confessions can lighten your burdens. We trust in the inherent goodness of people, their respect for the law, and their ability to find common ground even in conflicting ideas.
            </p>
            <p className="text-lg mb-12">
              We understand that people will always find a way to express themselves, so why not provide a platform that embraces freedom and aligns with the values of modern society? We believe in humanity and the power of genuine expression.
            </p>
            <div className="h-12"></div> {/* Spacer div */}
          </div>
          <p className="text-xl text-center">
            Join us at ConfesZ and be part of a community that values privacy, freedom, and authentic human connection.
          </p>
        </div>
      </div>
      {/* Bottom Image Section */}
      <div className="relative h-screen">
        <img
          src={communityImage}
          alt="Community"
          className="w-full h-full object-cover"
          style={{ filter: 'brightness(50%)' }}
        />
        {/* Optional overlay text for bottom image */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h2 className="text-3xl font-bold text-white">Join Our Community Today</h2>
        </div>
      </div>
    </div>
  );
}

export default About;